import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import {
	SET_SHOW_STEPPER,
	SET_SELECTED_SIGNAL,
	SET_SELECTED_ASSETS,
	SET_LIMIT_AND_NOTIFICATIONS,
	SET_CONFIGURATOR_VIEW,
	SET_FREQUENCY_LIMIT_MODELS,
	SET_UPDATE_RESULTS,
	SET_LIMITS_DISABLE,
	RESET_UPDATE_RESULTS,
	SET_FEEDBACK_MESSAGE,
	SET_LOADER_ON,
	SET_LOADER_OFF,
	SET_TURBINE_PARTIAL_ERROR,
	PUSH_FREQUENCY_LIMIT_MODEL
} from "./LimitConfiguratorActionsType";
import FrequencyTrendLimitConfigurationService from "../../service/FrequencyTrendLimitConfigurationService";
import ObjectHandleService from "@/services/common/ObjectHandleService";

const mutations = {
	[SET_SHOW_STEPPER](state, show)
	{
		state.showStepper = show;
	},
	[SET_CONFIGURATOR_VIEW](state, view)
	{
		state.configuratorView = view;
	},
	[SET]: (state, availableSignals) =>
	{
		state.availableSignals = availableSignals;
	},
	[SET_SELECTED_ASSETS]: (state, assets) =>
	{
		state.selectedAssets = assets;
	},
	[SET_SELECTED_SIGNAL]: (state, signal) =>
	{
		state.selectedSignal = signal;
	},
	[SET_LIMIT_AND_NOTIFICATIONS]: (state, settings) =>
	{
		state.limitAndNotificationsSettings = settings;
	},
	[SET_FREQUENCY_LIMIT_MODELS]: (state, models) =>
	{
		state.frequencyLimitModels = models;
	},
	[SET_UPDATE_RESULTS]: (state, results) =>
	{
		state.updateResults = results;
	},
	[RESET_UPDATE_RESULTS]: (state) =>
	{
		state.updateResults = [];
	},
	[SET_LIMITS_DISABLE]: (state, bool) =>
	{
		state.limitsDisable = bool;
	},
	[RESET_STATE]: (state) =>
	{
		Object.assign(state, FrequencyTrendLimitConfigurationService.EmptyLimitConfiguratorState());
	},
	[SET_FEEDBACK_MESSAGE]: (state, message) =>
	{
		state.feedbackMessage = message;
	},
	[SET_LOADER_ON]: (state) =>
	{
		state.isLoading = true;
	},
	[SET_LOADER_OFF]: (state) =>
	{
		state.isLoading = false;
	},
	[SET_TURBINE_PARTIAL_ERROR]: (state, error) =>
	{
		state.turbinePartialError = error;
	},
	[PUSH_FREQUENCY_LIMIT_MODEL]: (state, model) =>
	{
		if (ObjectHandleService.IsEmpty(model)) return;
		
		state.frequencyLimitModels.push(model);
	}
};

export default { mutations };
